import React from 'react';
import {Globals} from './../../../misc/helpers';
import './DebugMenu.css';
const DebugMenu = (props: any) => {
	return (
		<div className="ui-container" style={{
			top: '0',
			left: '0',
			zIndex: 10
		}}>
			<div className="ui-inner-container modal-disable-select">
				{
					Globals.showCorrectPath ? (
						<button className="debug-menu-button" onClick={() => {
							Globals.showCorrectPath = false;
							props.forceUpdate();
						}}>Hide Correct Path</button>
					) : (
						<button className="debug-menu-button" onClick={() => {
							Globals.showCorrectPath = true;
							props.forceUpdate();
						}}>Show Correct Path</button>
					)
				}
				{
					Globals.stopTimer ? (
						<button className="debug-menu-button" onClick={() => {
							Globals.stopTimer = false;
							props.forceUpdate();
						}}>Resume Timer</button>
					) : (
						<button className="debug-menu-button" onClick={() => {
							Globals.stopTimer = true;
							props.forceUpdate();
						}}>Stop Timer</button>
					)
				}
				<button className="debug-menu-button" onClick={() => {
							Globals.markCurrentScenarioAsCompleted = true;
							props.forceUpdate();
						}}>Mark Current Scenario As Completed</button>

				{
					Globals.skipAnimations ? (
						<button className="debug-menu-button" onClick={() => {
							Globals.skipAnimations = false;
							props.forceUpdate();
						}}>Unskip Animations &amp; Audio</button>
					) : (
						<button className="debug-menu-button" onClick={() => {
							Globals.skipAnimations = true;
							props.forceUpdate();
						}}>Skip Animations &amp; Audio</button>
					)
				}
			</div>
			
		</div>
	);
};

export default DebugMenu;
